module.exports = __webpack_public_path__ + "static/pinkunicorn5-30fa3e1acc4ba56816d6609e82270978.jpeg";